import React from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";

class DanhGiaCongViec extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text1: "",
    };
  }
  onChangeData = (field, event) => {
    let state = this.state;
    state[field] = event.target.value;
    this.setState(state);
  };

  render() {
    let props = this.props;

    return (
      <Modal
        {...props}
        size="modal-dialog"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i class="mdi mdi-thumb-up"></i>
            </span>{" "}
            Đánh giá công việc
          </h4>
          <button
            type="button"
            className="close-popup-new"
            data-dismiss="modal"
            aria-label="Close"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <form class="form tat-toan form-horizontal">
            <div class="form-body">
              <div class="form-body">
                <div class="col-md-12">
                  <div class="form-group ">
                    <label>Đánh giá</label>
                    <select class=" selectBox form-control input-sm">
                      <option value="0">Hoàn thành</option>
                      <option value="4">Không hoàn thành</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label>Lý do không hoàn thành</label>
                    <textarea
                      rows="2"
                      class="form-control input-sm"
                      name="comment"
                    ></textarea>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label>Nhận xét</label>
                    <textarea
                      rows="2"
                      class="form-control input-sm"
                      name="comment"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size">
          <a className="btn btn-new-main btn-checknew" href={() => false}>
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>{" "}
            Đánh giá
          </a>

          <a
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            href={() => false}
            onClick={props.onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </a>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default DanhGiaCongViec;
